export const ROUTES = {
  splash: '/',
  home: '/',
  about: '/about',
  faq: '/faq',
  blog: '/blog',
  pdfs: '/pdfs/',
  selectCaseStudy: '/select-case-study',

  login: '/login',
  annalyLogin: '/annaly/login',
  sso: '/sso',

  signup: '/signup',
  resetPassword: '/reset_password',
  resetPasswordApp: '/app/reset_password',
  termsOfService: '/terms-of-service',
  privacyPolicy: '/privacy-policy',
  termsOfServiceLegacy: '/terms_of_service',
  privacyPolicyLegacy: '/privacy_policy',

  forgotPasswordLegacy: '/app/forgot_password',
  forgotPassword: '/forgot-password',

  inReview: '/in-review',

  themeBuilder: '/theme-builder',

  evestmentQuery: '/evestment-query',
  rfpResponseQuery: '/rfp-response-query',
  rfpAdmin: '/rfp-response-admin',

  fedDigitalAnalyst: '/fed-digital-analyst',
  fedPublicReleaseAnalyst: '/the-fed-release-analyst',
  fedPublicSentimentAnalyst: '/the-fed-sentiment-analyst',
  fedLatestDocs: '/fed-latest-docs',

  digitalAnalyst: '/digital-analyst',
  chatDigitalAnalyst: '/chat-digital-analyst',
  rfpChatDigitalAnalyst: '/rfp-chat-digital-analyst',
  agentChatDigitalAnalyst: '/agent-chat-digital-analyst',
  researchDigitalAnalyst: '/research-digital-analyst',

  companySnapshot: '/company-snapshot',
  customSnapshot: '/custom-snapshot',

  docManagement: '/document-management',
  uploadSource: '/document-management',
  docUploadTriggers: '/document-upload-triggers',

  factor: '/factor',
  factorVisual: '/factor-visual',

  screener: '/screener',
  researchScreener: '/research-screener',

  growthEquityAnalysis: '/growth-equity-analysis',

  latestUpdates: '/latest-updates',
  latestEarningsUpdates: '/earnings-latest-updates',

  lenderEarningsUpdates: '/lender-earnings-analysis',

  stock: '/stock',
  securityDetail: '/security-detail',
  tagDetail: '/tag-detail',

  agentResult: '/agent-result',

  docViewer: '/view-document',
  docSummary: '/view-summary',

  compliance: '/compliance',
  queryHistory: '/query-history',

  docProcessingToDA: '/await-doc-processing',
  warningIndicators: '/warning-indicators',
  bullBearCases: '/bull-bear-cases',

  citations: '/citations',
  esgUpdates: '/esg-updates',

  newDealTriage: '/test-new-deal-triage',
  growthEquityMemo: '/test-growth-equity-memo-template',

  website: '/website-digital-analyst',
  webpageIngestion: '/website-summary',

  evaluationTemplate: '/eval-template',

  macroEconomicSignals: '/macro-economic-signals',
  economicImpact: '/economic-impact',

  textSearch: '/text-search',
  accountSettings: '/account-settings',
  watchlist: '/watchlist',

  liquidityTermsTableAnalysis: '/liquidity-terms-analysis',
  ppmTableAnalysis: '/ppm-analysis',
  tableAnalysis: '/table-analysis',
  creditAgreementAnalysis: '/credit-agreement-analysis',

  quarterlyDataTemplate: '/quarterly-data-template',
  earningsGridTemplate: '/earnings-grid-template',
  docGridAgent: '/doc-grid-agent',

  queryFlow: '/query-flow',
  reasoningQuery: '/reasoning-query',
  querySeries: '/query-series',
  dataAnalystAgent: '/data-analyst-agent',

  quickLook: '/quick-look',
  legacyQuickLook: '/quick-look-legacy',

  investmentMemo: '/investment-memo-template',

  clientMatrix: '/client-matrix-questions',
  clientPeerMatrix: '/peer-analysis-matrix-questions',
  clientQuery: '/client-ask-digital-analyst',

  peerBenchmarking: '/peer-benchmarking-template',

  agentScriptEditor: '/agent-script-editor',
  queryAgentScript: '/query-agent-script',

  flowAgentScriptEditor: '/flow-agent-script-editor',
  portfolioMonitoringTemplate: '/portfolio-monitoring-template',

  templateRedownload: '/template-redownload',
  filledTemplateDownload: '/filled-template-download',

  agentSpreadsheet: '/agent-spreadsheet',
  agentMemoryAdmin: '/agent-memory-admin',
  tableBuilderTool: '/table-builder-tool',

  ddqTemplate: '/ddq-template',
  documentTemplateProcessor: '/document-template-processor',

  brokerageAccount: '/brokerage-account',
  brokerageTaxDocuments: '/brokerage-documents',
};
